import React from 'react';
import { BsInfoCircle } from 'react-icons/bs';
import { Icon, IconButton, Tooltip } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import colors from '../../styles/theme/foundation/colors';

const InfoIconTooltip = ({
  toolTip
}) => (
  <Tooltip hasArrow borderRadius="md" label={toolTip} placement="top">
    <IconButton
      aria-label="info-icon-tooltip"
      boxSize={1}
      color={colors.greyScale['500']}
      icon={<Icon as={BsInfoCircle} />}
      variant="textGrey"
    />
  </Tooltip>
);

InfoIconTooltip.propTypes = { toolTip: PropTypes.string.isRequired };

export default InfoIconTooltip;
